import { useState, useEffect } from 'react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollTo = (id: string) => {
    setMobileOpen(false);
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70 py-3'
          : 'bg-transparent py-5'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6 flex items-center justify-between">
        <a
          href="#hero"
          onClick={(e) => { e.preventDefault(); scrollTo('hero'); }}
          className="flex items-center gap-2 cursor-pointer"
        >
          <span className="font-heading text-2xl font-bold tracking-tight text-foreground-950">
            A&Z<span className="text-primary-500">.</span>
          </span>
          <span className={`hidden sm:inline text-sm font-medium transition-colors duration-300 ${scrolled ? 'text-foreground-600' : 'text-foreground-700'}`}>
            Schoonmaakdienst
          </span>
        </a>

        <div className="hidden md:flex items-center gap-8">
          {[
            { id: 'diensten', label: 'Diensten' },
            { id: 'over-ons', label: 'Over ons' },
            { id: 'voor-wie', label: 'Voor wie' },
            { id: 'contact', label: 'Contact' },
          ].map((link) => (
            <a
              key={link.id}
              href={`#${link.id}`}
              onClick={(e) => { e.preventDefault(); scrollTo(link.id); }}
              className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                scrolled ? 'text-foreground-700 hover:text-primary-500' : 'text-foreground-800 hover:text-primary-500'
              }`}
            >
              {link.label}
            </a>
          ))}
        </div>

        <div className="hidden md:flex items-center gap-4">
          <a
            href="tel://+31641405833"
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-semibold whitespace-nowrap hover:bg-primary-600 transition-colors duration-200 cursor-pointer"
          >
            <i className="ri-phone-line text-base"></i>
            Bel ons
          </a>
        </div>

        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-800 cursor-pointer"
          aria-label="Menu openen"
        >
          <i className={`ri-${mobileOpen ? 'close' : 'menu'}-line text-2xl`}></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-4 flex flex-col gap-3">
            {[
              { id: 'diensten', label: 'Diensten' },
              { id: 'over-ons', label: 'Over ons' },
              { id: 'voor-wie', label: 'Voor wie' },
              { id: 'contact', label: 'Contact' },
            ].map((link) => (
              <a
                key={link.id}
                href={`#${link.id}`}
                onClick={(e) => { e.preventDefault(); scrollTo(link.id); }}
                className="text-sm font-medium text-foreground-700 hover:text-primary-500 py-2 transition-colors whitespace-nowrap cursor-pointer"
              >
                {link.label}
              </a>
            ))}
            <a
              href="tel://+31641405833"
              className="inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-semibold whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer mt-2"
            >
              <i className="ri-phone-line text-base"></i>
              Bel ons
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}